import script from "./HTpvpTFGamePlay.vue?vue&type=script&setup=true&lang=js"
export * from "./HTpvpTFGamePlay.vue?vue&type=script&setup=true&lang=js"

import "./HTpvpTFGamePlay.vue?vue&type=style&index=0&id=db80d824&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db80d824"]])

export default __exports__